const InsuranceChallenge2InitialText ="Not all advice is good advice, especially when it comes " +
    "to insurance. Below is a mix of tips you might hear from friends, family, or online. Drag " +
    "each one to 'Good Advice' if it's something you should follow, or 'Advice that is Not Good' if it does " +
    "not sound like a good idea.  Click the 'Done' button when you have finished sorting all of " +
    "the items."

export default InsuranceChallenge2InitialText 
